import React, { useEffect, useRef } from "react";
import dateFormat from "dateformat";

const redIcon = new window.L.Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const greenIcon = new window.L.Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

function PopupTableComponent(device) {
  return `<div style="width: 300px;">
            <table style="font-weight: bold; width: 300px;">
                <tr>
                    <td><h6>Serial No: ${
                      device.provisioned_device.serial_no
                    }</h6></td>
                </tr>
                <tr>
                    <td><h6>Mac Address: ${
                      device.provisioned_device.mac_address
                    }</h6></td>
                </tr>
                <tr>
                    <td><h6>Model: ${
                      device.provisioned_device.model_no
                    }</h6></td>
                </tr>
                <tr>
                    <td><h6>Latitude, Longitude: ${device.device_latitude.toFixed(
                      4
                    )}, ${device.device_longitude.toFixed(4)}</h6></td>
                </tr>
                <tr>
                    <td><h6>Last Updated Time: ${dateFormat(
                      device.device_updated_at
                    )} UTC</h6></td>
                </tr>
            </table>
        </div>`;
}

export default function MapcontainerComponent(props) {
  const mapRef = useRef(null);

  const activeDevices = props.devices.filter(
    (device) =>
      device.device_state !== -1 &&
      (parseInt(device.device_longitude) ||
        parseInt(device.device_latitude)) !== 0
  );

  const inactiveDevices = props.devices.filter(
    (device) =>
      device.device_state === -1 &&
      (parseInt(device.device_longitude) ||
        parseInt(device.device_latitude)) !== 0
  );

  const inactiveDevicesLegend =
    "Inactive Devices (" + inactiveDevices.length + ")";
  const activeDevicesLegend = "Active Devices (" + activeDevices.length + ")";

  useEffect(() => {
    try {
      const initMap = () => {
        mapRef.current = new window.MapmyIndia.Map("map", {
          center:
            props.devices.length === 1
              ? [
                  props.devices[0].device_latitude,
                  props.devices[0].device_longitude,
                ]
              : [23.0, 80.32],
          zoom: 5,
          zoomControl: true,
          touchZoom: true,
          location: { control: false },
        });

        updateMap();
      };

      const updateMap = () => {
        // Remove old marker cluster layers
        mapRef.current.eachLayer((layer) => {
          if (layer instanceof window.L.MarkerClusterGroup) {
            mapRef.current.removeLayer(layer);
          }
        });

        const activeCluster = window.L.markerClusterGroup();
        const inactiveCluster = window.L.markerClusterGroup();

        // Active markers
        activeDevices.forEach((device) => {
          const marker = window.L.marker(
            [device.device_latitude, device.device_longitude],
            {
              icon: greenIcon,
              title: device.provisioned_device.mac_address,
            }
          ).bindPopup(PopupTableComponent(device));
          activeCluster.addLayer(marker);
        });
        mapRef.current.addLayer(activeCluster);

        // Inactive markers
        inactiveDevices.forEach((device) => {
          const marker = window.L.marker(
            [device.device_latitude, device.device_longitude],
            {
              icon: redIcon,
              title: device.provisioned_device.mac_address,
            }
          ).bindPopup(PopupTableComponent(device));
          inactiveCluster.addLayer(marker);
        });
        mapRef.current.addLayer(inactiveCluster);

        // Add single layer control
        const overlayMaps = {};
        if (activeDevices.length > 0)
          overlayMaps[activeDevicesLegend] = activeCluster;
        if (inactiveDevices.length > 0)
          overlayMaps[inactiveDevicesLegend] = inactiveCluster;

        window.L.control
          .layers(null, overlayMaps, {
            position: "topleft",
            collapsed: false,
          })
          .addTo(mapRef.current);
      };

      if (!mapRef.current) {
        initMap();
      } else {
        updateMap();
      }

      return () => {
        if (mapRef.current) {
          mapRef.current.remove();
          mapRef.current = null;
        }
      };
    } catch (error) {
      console.error("Error in mapRef.current: ", error);
    }
  }, []);

  const h4style = {
    position: "absolute",
    top: "15px",
    zIndex: "9999",
    textAlign: "right",
    left: "50%",
    marginLeft: "-75px",
    paddingLeft: "400px",
    color: "white",
  };

  return (
    <div style={{ height: "100%" }}>
      <h4 style={h4style}>
        Total Devices ({activeDevices.length + inactiveDevices.length})
      </h4>
      <div
        id="map"
        style={{
          width: "100%",
          height: "100%",
        }}
      ></div>
      <style>
        {`
          .leaflet-control-layers-overlays {
            padding: 5px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            gap: 5px;
          }
          .leaflet-control-layers-overlays label div {
            margin: 0;
            display: flex;
            gap: 5px;
            align-items: center;
          }
          .leaflet-control-layers-overlays input[type="checkbox"] {
            margin: 0;
          }
        `}
      </style>
    </div>
  );
}
